(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    /*
   * On real touch devices there is no mouse, so 'pointerenter' never fires and the
   * second product image never shows. As soon as a finger touches a card-gallery,
   * we dispatch a synthetic 'pointerenter' event so the theme's existing hover
   * logic (on:pointerenter="/previewImage") runs exactly like it does on desktop.
   * pointerType is explicitly set to 'mouse' since the handler checks it (many
   * themes intentionally ignore touch-originated pointer events).
   * The tap then continues normally and opens the product page.
   *
   * Note: we intentionally do NOT reset back to the first image on touchend —
   * dispatching a synthetic 'pointerleave' there interferes with the click/
   * navigation that follows and can block the tap from opening the product page.
   * Since the tap navigates away immediately anyway, there is no visible moment
   * where the reset would even be noticed.
   */
  document.addEventListener(
    'touchstart',
    (event) => {
      const gallery = event.target.closest('.card-gallery');
      if (gallery) {
        gallery.dispatchEvent(
          new PointerEvent('pointerenter', {
            bubbles: true,
            pointerType: 'mouse',
            isPrimary: true,
            pointerId: 1,
          })
        );
      }
    },
    { passive: true }
  );
  } catch(e) { console.error(e); }
})();

})();
